(() => {
    let scheduled = false;

    const getKey = (el) => el.getAttribute('data-section') || el.id || '__variant-selects__';

    const dedupe = () => {
        scheduled = false;
        const keptByKey = new Map();

        document.querySelectorAll('variant-selects').forEach((el) => {
            const key = getKey(el);
            if (!keptByKey.has(key)) {
                keptByKey.set(key, el);
                return;
            }

            const keep = keptByKey.get(key);
            const elPrecedesKeep = keep.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING;

            if (elPrecedesKeep) {
                keep.remove();
                keptByKey.set(key, el);
            } else {
                el.remove();
            }
        });
    };

    const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(dedupe);
    };

    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', schedule);
})();
